import { useEffect, useState } from "react";
import { Trophy, Loader2, Crown, Target } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageShell } from "@/components/Layout";

export default function Leaderboard() {
  const { user } = useAuth();
  const [board, setBoard] = useState(null);

  useEffect(() => {
    (async () => {
      const lb = await api.get("/leaderboard");
      setBoard(lb.data);
    })();
  }, []);

  return (
    <PageShell testid="leaderboard-page">
      <div className="mb-8">
        <span className="overline">Cumulative Champion Standings · Regular + Playoffs</span>
        <h1 className="font-display text-4xl font-black tracking-tight mt-2 flex items-center gap-3">
          <Trophy className="h-8 w-8 neon-text" /> Leaderboard
        </h1>
      </div>

      {!board ? (
        <div className="flex justify-center py-24"><Loader2 className="h-8 w-8 neon-text animate-spin" /></div>
      ) : board.length === 0 ? (
        <p className="text-zinc-500 py-16 text-center">No players yet.</p>
      ) : (
        <div className="rounded-2xl border border-[#1F1F22] bg-[#0A0A0A] overflow-hidden" data-testid="leaderboard-table">
          <div className="grid grid-cols-12 px-5 py-3 text-xs font-bold text-zinc-500 border-b border-[#1F1F22] uppercase tracking-wider">
            <div className="col-span-2">Rank</div>
            <div className="col-span-5">Player</div>
            <div className="col-span-2 text-right">Record</div>
            <div className="col-span-1 text-right">TB±</div>
            <div className="col-span-2 text-right">Points</div>
          </div>
          {board.map((row) => {
            const isMe = row.user_id === user?.id;
            return (
              <div key={row.user_id} data-testid={`lb-row-${row.rank}`}
                className={`grid grid-cols-12 items-center px-5 py-4 border-b border-[#141416] last:border-0 ${isMe ? "bg-[#D50A0A]/5" : ""}`}>
                <div className="col-span-2 flex items-center gap-2">
                  {row.rank <= 3 && <Crown className={`h-4 w-4 ${row.rank === 1 ? "text-amber-400" : row.rank === 2 ? "text-zinc-300" : "text-amber-700"}`} />}
                  <span className={`font-display font-black text-lg ${row.rank <= 3 ? "neon-text" : "text-zinc-400"}`}>{row.rank}</span>
                </div>
                <div className="col-span-5 font-semibold text-sm flex items-center gap-2">
                  {row.display_name}{isMe && <span className="text-zinc-500">(you)</span>}
                </div>
                <div className="col-span-2 text-right text-zinc-300 text-sm font-semibold">{row.record ?? "—"}</div>
                <div className="col-span-1 text-right text-zinc-500 text-xs">{row.tiebreaker_error ?? "—"}</div>
                <div className="col-span-2 text-right font-display font-bold">{row.points}</div>
              </div>
            );
          })}
          <div className="px-5 py-3 text-[11px] text-zinc-600 flex items-center gap-1.5">
            <Target className="h-3.5 w-3.5" /> Ranked by Showdown record, then points, then combined-score tiebreaker (TB±, lower is better).
          </div>
        </div>
      )}
    </PageShell>
  );
}
